<template>
  <div class="main-container">
    <div class="main-container-wrapper">
      <div class="flex-content-space-between">
        <div class="left-content">
          <img src="../assets/menu_logo.png" alt="" />
          <h1>全国一体化在线政务服务平台<br />国家文物局综合行政管理平台</h1>
        </div>
        <div class="right-content">
            <li class="marg" @click="pat()">
              <el-tooltip
                class="item"
                effect="dark"
                content="门户首页"
                placement="bottom-start"
              >
                <!-- <span @click="pat()"> 首页 </span> -->
                <svg-icon class="opt_icon" icon-class="site"></svg-icon>
              </el-tooltip>
            </li>
            <li>
              <a :href="jumpAddress+'?type=2'">个人登录</a>
            </li>
            <li>
              <a :href="jumpAddress+'?type=1'">法人登录</a>
            </li>
            <li>
              <a href="#">·</a>
            </li>
            <li>
              <a href="#">注册</a>
            </li>
            <li>|</li>
            <li>
              <a :href="jumpAddress+'?type=3'"
                >审批监管入口</a
              >
            </li>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { url, jumpAddress } from "../utils/axiosUrl";
export default {
  name: "registerHeader",
  data() {
    return {
      url: url,
      jumpAddress: jumpAddress
    };
  },
  methods: {
    pat() {
      this.$router.push({
        path: "/home",
        query: {},
      });
    },
  },
};
</script>
<style scoped lang='less'>
@import "../styles/theme";
.item {
  // margin: 4px;
  font-size: 25px;
  color: #fff !important;
}
.main-container {
  background: @theme-color;
  height: 60px;
  //   height: @height-menu-bar;
}
.left-content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 60px;

  h1 {
    display: inline-block;
    color: #fff;
    font-size: 18px;
    margin: 0 0 0 10px;
  }
}

.right-content {
  li {
    position: relative;
    display: inline-block;
    font-weight: 700;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
    margin-right: 10px;
  }
  a {
    padding: 0 5px;
    line-height: 60px;
    height: 60px;
    text-align: right;
    font-weight: 700;
    font-size: 14px;
  }
}
.img {
  width: 30px;
  height: 30px;
  color: #fff;
}
</style>
